"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppMediaProvider = exports["default"] = exports.DeviceTypes = void 0;
var _device = _interopRequireDefault(require("baseStyles/enums/device"));
var _useTopWindowSize = require("hooks/useTopWindowSize");
var _react = _interopRequireWildcard(require("react"));
var _reactResponsive = require("react-responsive");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var DeviceTypes = _device["default"].types;
exports.DeviceTypes = DeviceTypes;
;
var AppMediaProviderContext = /*#__PURE__*/_react["default"].createContext({});
var AppMediaProvider = function AppMediaProvider(_ref) {
  var children = _ref.children;
  var windowSize = (0, _useTopWindowSize.useTopWindowSize)();
  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    minWidth: _device["default"].breakpoints[_device["default"].types.Desktop].min
  }, windowSize);
  var isTablet = (0, _reactResponsive.useMediaQuery)({
    minWidth: _device["default"].breakpoints[_device["default"].types.Tablet].min,
    maxWidth: _device["default"].breakpoints[_device["default"].types.Tablet].max
  }, windowSize);
  var isMobile = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _device["default"].breakpoints[_device["default"].types.Mobile].max
  }, windowSize);
  var isMobileLandscape = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _device["default"].breakpoints[_device["default"].types.Mobile].max,
    orientation: "landscape"
  }, windowSize);
  var currentDevice = (0, _react.useMemo)(function () {
    if (isDesktop) return _device["default"].types.Desktop;else if (isTablet) return _device["default"].types.Tablet;else if (isMobile) return _device["default"].types.Mobile;else if (isMobileLandscape) return _device["default"].types.MobileLandscape;
  }, [isDesktop, isTablet, isMobile, isMobileLandscape]);
  var values = {
    isDesktop: isDesktop,
    isTablet: isTablet,
    isMobile: isMobile,
    isMobileLandscape: isMobileLandscape,
    currentDevice: currentDevice
  };
  return /*#__PURE__*/_react["default"].createElement(AppMediaProviderContext.Provider, {
    value: values,
    "data-sentry-element": "unknown",
    "data-sentry-component": "AppMediaProvider",
    "data-sentry-source-file": "AppMediaProvider.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-width": windowSize.width,
    "data-height": windowSize.height,
    className: "media-device-".concat(currentDevice)
  }, children));
};
var useAppMediaProvider = function useAppMediaProvider() {
  var context = (0, _react.useContext)(AppMediaProviderContext);
  if (!context) {
    // throw Error(`Use ${useAppMediaProvider.name} in ${AppMediaProviderContext.displayName}`);
    console.warn("Use ".concat(useAppMediaProvider.name, " in ").concat(AppMediaProviderContext.displayName));
  }
  return context;
};
exports.useAppMediaProvider = useAppMediaProvider;
var _default = AppMediaProvider;
exports["default"] = _default;